<template>
	<b-card
		bg-variant="white"
		border-variant="white"
		text-variant="dark"
		class="shadow-sm top-right-no-radius"
	>
		<b-card-title title-tag="h3" class="text-primary">Available Closure Questions</b-card-title>

		<b-list-group flush>
			<!-- 

					cq loop
							
			-->

			<cqItem v-for="cq  in closureQuestions" :cq="cq" :key="cq.id">
				<template v-slot:button>
					<b-button @click="assignCQtoTemplate(cq)" size="sm" variant="success">
						<font-awesome-icon :icon="['fas', 'plus']" fixed-width />&nbsp;add
					</b-button>
				</template>
			</cqItem>
			<b-list-group-item class="py-5" variant="secondary">
				<b-form-row>
					<b-col cols="12">
						<!-- 

							new closure question form 

						-->
						<b-form-group
							label-cols-sm="12"
							label-cols-md="4"
							label-cols-lg="4"
							label-cols-xl="3"
							label-align-md="right"
							label-align-sm="left"
							label="New Closure Question:"
							label-size="sm"
							label-class="text-body"
							class="mb-0"
						>
							<b-input-group size="sm">
								<b-form-input id="title-new-cq" type="text" v-model="form.title" />
								<b-input-group-append>
									<b-button
										@click.prevent="assignNewCQtoTemplate"
										:disabled="form.title==''"
										variant="success"
									>
										<font-awesome-icon :icon="['fas', 'plus']" fixed-width />&nbsp;add
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-form-row>
			</b-list-group-item>
		</b-list-group>
	</b-card>
</template>

<script>
	import cqItem from "@/components/closureQuestion/closureQuestionListItem.vue";

	export default {
		name: "closureQuestionList_component",

		components: { cqItem },

		props: {
			closureQuestions: {
				type: Array,
				default: function() {
					return [];
				}
			},
			langauge_id: {
				type: Number,
				default: function() {
					return null;
				}
			}
		},

		data() {
			return {
				form: {
					title: "",
					lang: this.langauge_id
				}
			};
		},

		methods: {
			// assign closure question
			assignCQtoTemplate(cq) {
				this.$emit("assign", cq);
			},

			// assign brandly new created (input field) closure question
			assignNewCQtoTemplate() {
				this.assignCQtoTemplate({
					title: this.form.title,
					language_id: this.form.lang
				});
				// reset form
				this.form.title = "";
			}
		}
	};
</script>

<style>
</style>
